import { render } from "./fish.vue?vue&type=template&id=1c47bf44&scoped=true"
import script from "./fish.vue?vue&type=script&lang=js"
export * from "./fish.vue?vue&type=script&lang=js"

import "./fish.vue?vue&type=style&index=0&id=1c47bf44&lang=scss&scoped=true"
import "./fish.vue?vue&type=style&index=1&id=1c47bf44&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c47bf44"]])

export default __exports__